module.exports = __webpack_public_path__ + "img/ico_prod_type_list.0216ce9.svg";